<template>
    <div>
        <h1 v-if="isLoaded">JSON DE {{ first.data.label}} (et tous ses enfants)</h1>
        <span> Doit être rechargé si modifications</span>
<hr>
        <div class="textwrapper" v-if="isLoaded"><textarea v-model="showAll"  rows="50"> </textarea></div>
    </div>
</template>

<script>

    import nodeClass from '../classes/jsonNodeExportModel.js'
    import linkClass from '../classes/jsonLinkExportModel.js'
    import elementClass from '../classes/jsonElementExportModel.js'

    export default {
        components:{
        },
        data(){
            return {
                id:this.$route.params.id,
                first:{},
                jsonFinal:{
                    elements:{},
                    nodes:{},
                    liens:[]
                },
                isLoaded:false
            }
        },
        computed: {

            showAll(){
               let result= JSON.stringify(this.jsonFinal)
                return result
            },
        },
        methods: {

            async loadFirst(){


                //1 on charge tous les éléments
                const tabElement=await this.$mydb.do.getElementListAll()

                for(const res of tabElement){
                    const myEl=new elementClass(res)

                    // trouve les carac de l'élément
                    const carac=await this.$mydb.do.getCaracLieu(myEl.slug)

                    for(const myParam of carac){
                        //Tout sauf lui-meme
                        if(myEl.slug!==myParam.clef)
                            myEl.addCarac(myParam)
                    }

                    //trouve les lieux d'usage des carac de cet element
                    const lieux=await this.$mydb.do.searchBegin(myEl.slug)

                    for(const myLieu of lieux){
                        //tout sauf lui-meme
                        if(myLieu.lieu!==myEl.slug)
                            myEl.addLieu(myLieu)
                    }

                    //trouve les dialogue où cet element est locuteur
                    const dialog=await this.$mydb.do.searchDialogues(myEl.id)
                    for(const myDial of dialog){
                        myEl.addDialogue(myDial.id)
                    }

                    //this.jsonFinal.elements.push(myEl)
                    this.jsonFinal.elements[myEl.slug]=myEl
                }

                //2 on loop sur les Nodes
                const tmp=await this.$mydb.do.getTask(this.id)
                this.first=tmp
                this.first.parent=""
                const parsed=await this.buildJsonTask(this.first)

                //this.jsonFinal.nodes.push(parsed)
                this.jsonFinal.nodes[parsed.id]=parsed

                await this.loadChildrenOf(this.first)

                this.isLoaded=true
                return true
            },

            async loadChildrenOf(target) {
                const tmp=await this.$mydb.do.getChildrenOfTask(target.id)

                for(const res of tmp){
                    const parsed=await this.buildJsonTask(res)
                    //this.jsonFinal.nodes.push(parsed)
                    this.jsonFinal.nodes[parsed.id]=parsed

                    await this.loadChildrenOf(res)
                }
            },

            async buildJsonTask(target){

                // creation de l'objet
                const myJson=new nodeClass(target)


                // get les requis
                const requis=await this.$mydb.do.getCaracLieu(myJson.id)

                for(const myParam of requis){
                    myJson.addCarac(myParam)
                }

                //get les sorties
                const sorties=await this.$mydb.do.getResultatOutOf(target.id)
                for(const mySortie of sorties){
                    myJson.addSortie(mySortie)

                    const params=await this.$mydb.do.getCaracLieu(mySortie.id)

                    for(const myParam of params){
                        myJson.addCarac(myParam)
                    }

                }

                //get les link sortantes
                const linkOut=await this.$mydb.do.getLinkOutOf(target.id)
                    for(const myLink of linkOut){
                        myJson.addLinkTo(myLink)

                        myLink.level=target.level
                        const theLink=new linkClass(myLink)
                        this.jsonFinal.liens.push(theLink)

                    }

                //get les link entrante
                const linkIn=await this.$mydb.do.getLinkGoingTo(target.id)
                for(const myLink of linkIn){
                    myJson.addLinkIn(myLink)
                    myLink.level=target.level
                }


                return myJson
            }

        },
        mounted() {
            this.loadFirst()
        },
    }

</script>


<style lang="scss">
    textarea
    {
        width:100%;
    }
    .textwrapper
    {
        border:1px solid #999999;
        margin:5px 0;
        padding:3px;
    }
    h1{
        font-size:2em !important;
    }

</style>